<template>
  <CommonSidePanel
    :model-value="open"
    :width="540"
    @update:model-value="$emit('update:open', $event)"
  >
    <v-toolbar
      flat
      color="primary"
      class="panel-header"
    >
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card flat>
      <v-card-text>
        <DashboardCardFiltersFields
          :model-value="draft"
          :source="source"
          column
          :date-label="dateLabel"
          :default-start-date="defaultStartDate"
          :default-end-date="defaultEndDate"
          :loading="loading"
          :filter-loading="filterLoading"
          @update:model-value="draft = $event"
        />
      </v-card-text>
      <v-card-actions class="sc-navigation-drawer-actions">
        <v-spacer />
        <v-btn variant="text" class="cancel" @click="close">Cancel</v-btn>
        <v-btn color="primary" data-track="report.dashboard-filters.apply" @click="apply">Apply</v-btn>
      </v-card-actions>
    </v-card>
  </CommonSidePanel>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';

import { IDashboardCardFilters } from '@/bundles/Dashboard/interfaces';

import DashboardCardFiltersFields from '@/bundles/Dashboard/components/filters/DashboardCardFiltersFields.vue';
import CommonSidePanel from '@/bundles/Common/components/panels/CommonSidePanel.vue';

interface IDashboardCardFiltersData {
  draft: IDashboardCardFilters;
}

export default defineComponent({
  name: 'DashboardCardFilters',

  components: { CommonSidePanel, DashboardCardFiltersFields },

  props: {
    modelValue: {
      type: Object as PropType<IDashboardCardFilters>,
      required: true,
    },
    source: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    open: Boolean,
    dateLabel: {
      type: String,
      default: '',
    },
    defaultStartDate: {
      type: String,
      default: '',
    },
    defaultEndDate: {
      type: String,
      default: '',
    },
    loading: Boolean,
    filterLoading: Boolean,
  },

  emits: ['update:modelValue', 'update:open'],

  data (): IDashboardCardFiltersData {
    return {
      draft: { ...this.modelValue },
    };
  },

  watch: {
    open (isOpen: boolean) {
      // re-snapshot on every opening so closing without apply reverts the draft
      if (isOpen) {
        this.draft = { ...this.modelValue };
      }
    },
  },

  methods: {
    close () {
      this.$emit('update:open', false);
    },
    apply () {
      this.$emit('update:modelValue', this.draft);
      this.close();
    },
  },
});
</script>
